import React from 'react'
import injectSheet from 'react-jss'
import { OptionGroup } from '../../'

const HouseDetailItem = (props) => {
  const {
    classes,
    compareOption,
    handleClick,
    index,
    node,
    selection,
  } = props

  const isSelected = selection.includes(node.id)

  const conflicts = (Array.isArray(node.conflicts) && (node.conflicts.length > 0) && (
    node.conflicts.filter(element => selection.includes(element))
  ))

  const requires = (Array.isArray(node.requires) && (node.requires.length > 0) && (
    node.requires.filter(element => !selection.includes(element))
  ))

  return (
    <div className={`${classes.itemContainer}`}>
      <div className={`${classes.itemContainerDiv}`}>
        <OptionGroup
          compareOption={compareOption}
          conflicts={conflicts}
          index={index}
          isSelected={isSelected}
          node={node}
          handleClick={handleClick}
          requires={requires}
        />
      </div>
    </div>
  )
}

const styles = theme => ({
  itemContainer: {
    padding: `${theme.sizes.gutter / 2}px`,
  },
  itemContainerDiv: {
    margin: `${theme.sizes.gutter / 2}px 0`,
    '& > div': {
      outlineWidth: '5px',
      outlineStyle: 'solid',
      outlineColor: 'transparent',
      transition: [
        {
          property: 'outline-color',
          duration: theme.speed.fast,
        },
      ],
      '&:hover': {
        outlineColor: theme.colors.main_1,
      },
    },
  },
})

export default injectSheet(styles)(HouseDetailItem)



// WEBPACK FOOTER //
// ./src/modules/houseType/components/houseTypeDetailItem.jsx